import { useState, Fragment } from 'react';
import { SidebarLayoutNew } from '../components/sidebar-layout-new';
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { DocumentPlusIcon, PlusIcon } from '@heroicons/react/16/solid';
import { Footer } from '../components/footer';
import { Button } from '../components/button';
import { Heading } from '../components/heading';
import { ErrorMessage, Field, Label } from '../components/fieldset';
import { Input } from '../components/input';
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import config from '../config.js'
const breadcrumbs_link = [
  { name: "Add New Company", href: "/add-new-company" }, 
  { name: "GB Feed", href: "#",current: true}  
];
const page_info = `Here you can add company using GB feed details`; 

export default function AddNewCompany() {
  const [successMsg, setSuccessMsg] = useState('');
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showErrorBox, setShowErrorBox] = useState(false);
  
  const [formData, setFormData] = useState({ account_name: '',country:'',url:'',gb_feed_link:'' });
  const [errors, setErrors] = useState(new Map());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when typing
    setErrors((prev) => {
      const newErrors = new Map(prev);
      newErrors.delete(name);
      return newErrors;
    });
  };

  const validate = () => {
    const newErrors = new Map();
    if (!formData.account_name.trim()) {
      newErrors.set('account_name', 'Account Name is required');
    }
	if (!formData.country.trim()) {
      newErrors.set('country', 'country is required');
    }
	if (!formData.url.trim()) {
      newErrors.set('url', 'Website URL is required');
    }else {
	  try {
		new URL(formData.url); // throws if invalid
	  } catch (_) {
		newErrors.set('url', 'Please enter a valid URL');
	  }
  }
	
	
	if (!formData.gb_feed_link.trim()) {
      newErrors.set('gb_feed_link', 'GB Feed Link is required');
    }else {
	  try {
		new URL(formData.gb_feed_link); // throws if invalid
	  } catch (_) {
		newErrors.set('gb_feed_link', 'Please enter a GB Feed Link');
	  }
   }
    return newErrors;
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (validationErrors.size > 0) {
      setErrors(validationErrors);
      return;
    }

    console.log('Form submitted:', formData);
    // Submit via fetch or axios
     
		fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=add_company_gb`,
			{method: 'POST', headers: {'Content-Type': 'application/json'},credentials: 'include',body: JSON.stringify(formData)}
		)
		.then(response => response.json())
		.then(data => {
		  console.log('Success:', data);
		  
		  if(data.status==='success'){
			setSuccessMsg(data.msg);
			setShowSuccessBox(true);
			setTimeout(() => {
				setShowSuccessBox(false);
				setSuccessMsg("");
			}, 3000);
		  }else{
			  setErrorMsg(data.msg);
			  setShowErrorBox(true);
			  setTimeout(() => {
				  setShowErrorBox(false);
				  setErrorMsg("");
			  }, 3000);
		  }
		  
		})
		.catch(error => {
		  console.error('Error:', error);
		  
		  setErrorMsg('Sorry, Add company process failed! '+error);
		  setShowErrorBox(true);
		  setTimeout(() => {
			  setShowErrorBox(false);
			  setErrorMsg("");
		  }, 3000);
		
		});
		//const data = await res.json();
	 

    // Reset if needed
    setFormData({ account_name: '',country:'',url:'',gb_feed_link:'' });
    setErrors(new Map());
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setFormData({ account_name: '',country:'',url:'',gb_feed_link:'' });
    setErrors(new Map());
  };

  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="addnewcompany">
	  <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
      <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	  <BreadcrumbsNew pages={breadcrumbs_link} />
	  <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
		<DocumentPlusIcon className="!size-8" />
		<Heading>Link From GB Feed</Heading>
	  </div>
      <PageInfo info={page_info} />
        <div className="min-w-full">
         
            <form className="p-4 space-y-4 max-w-md">
              <Field className="mt-3">
                <Label>Account Name <span className="text-red-500">*</span></Label>
				
				  <Input name="account_name" value={formData.account_name} onChange={handleChange} invalid={errors.has('account_name')} className="w-full sm:max-w-sm"
				  />
				  {errors.has('account_name') && (
					<ErrorMessage>{errors.get('account_name')}</ErrorMessage>
				  )}
				
              </Field>
			  
			  <Field className="mt-3">
                <Label>Country <span className="text-red-500">*</span></Label>
				
                <Input name="country" value={formData.country} onChange={handleChange} invalid={errors.has('country')} className="w-full sm:max-w-sm"
                />
                {errors.has('country') && (
                  <ErrorMessage>{errors.get('country')}</ErrorMessage>
                )}
				
              </Field>
			  
			  <Field className="mt-3">
                <Label>Website URL <span className="text-red-500">*</span></Label>
				
                <Input name="url" type="url" value={formData.url} onChange={handleChange} invalid={errors.has('url')} className="w-full sm:max-w-sm"/>
                {errors.has('url') && (
                  <ErrorMessage>{errors.get('url')}</ErrorMessage>
                )}
				
              </Field>
			  
			  <Field className="mt-3">
                <Label>GB Feed Link <span className="text-red-500">*</span></Label>
				
                <Input name="gb_feed_link" value={formData.gb_feed_link} onChange={handleChange} invalid={errors.has('gb_feed_link')} className="w-full sm:max-w-sm"
                />
                {errors.has('gb_feed_link') && (
                  <ErrorMessage>{errors.get('gb_feed_link')}</ErrorMessage>
                )}
				
              </Field>

              <div className="flex gap-3 items-center">
                <button 
					className="inline-flex justify-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 cursor-pointer"
					onClick={handleSubmit}>
                  <PlusIcon aria-hidden="true" className="-ml-0.5 size-5 text-white"/>
                  Add Company
                </button>
                <Button color="zinc" onClick={handleCancel}>Clear</Button>
              </div>
            </form>
		
          
        </div>
      </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}
